export const initialState = {
  items: [],
  recent: [],
  status: {
    hasNew: false,
    shouldPopup: false,
    lastSeen: null,
  },
  loading: false,
  error: null,
}
